import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import { Button, Input, Progress, Spin } from "antd";
import { Message, ViewInput } from "../../../GlobalStyles";
import { MdBook, MdCheckCircleOutline, MdFileDownload } from "react-icons/md";

export default function CoursesPublic() {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");

  useEffect(() => {
    listCourses();
  }, [filterSearch]);

  useEffect(() => {
    redirect();
  }, []);

  function redirect() {
    if (user.type == "admin") {
      listCourses();
    } else {
      if (user.type == "cliente") {
        listCourses();
      } else {
        navigate(-1);
      }
    }
  }

  async function listCourses() {
    await api
      .get(`/courses-user`)
      .then((response) => {
        let courses = response.data;
        if (user.course_restricted) {
          let coursesEdit = courses.filter((item) => {
            return item.restricted == true;
          });
          coursesEdit = [
            ...coursesEdit,
            ...courses.filter((item) => {
              return item.restricted == false;
            }),
          ];
          setCourses(coursesEdit);
        } else {
          setCourses(courses);
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h1>{!loading ? courses.length : ""} Modulos</h1>
        <Button
          style={{
            borderRadius: 50,
          }}
          type="primary"
          onClick={() => {
            navigate(`/certificado`);
          }}
        >
          <MdFileDownload size={14} />
          Baixar Certificado
        </Button>
      </div>
      <div className="filter">
        <ViewInput style={{ flex: 1, maxWidth: 350 }}>
          <p>Pesquisar</p>
          <Input.Search
            value={filter}
            onChange={(text) => {
              setFilter(text.target.value);
            }}
            placeholder="pesquisar"
            onSearch={(text) => {
              setFilterSearch(text);
            }}
            allowClear
            onClear={() => {
              setFilterSearch("");
            }}
            enterButton
          />
        </ViewInput>
      </div>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          {courses.length == 0 && <Message>Nenhum modulo encontrado</Message>}
          {courses.map((item, idx) => {
            return (
              <div className="module">
                <div className="title">
                  <h4>{item.name}</h4>
                  <p>{item.description}</p>
                </div>
                {loading ? (
                  <Spin style={{ marginTop: 50 }} size="large" />
                ) : (
                  <>
                    {item.courses?.length == 0 && (
                      <Message>Nenhum curso encontrado</Message>
                    )}
                    <div className="courses">
                      {item.courses?.map((data, index) => {
                        const totalConfirm = data.lessons.reduce(
                          (acc, data) => acc + data.confirms.length,
                          0
                        );
                        const totalConfirmBack = index
                          ? item.courses[index - 1].lessons.reduce(
                              (acc, data) => acc + data.confirms.length,
                              0
                            )
                          : 0;
                        const totalBack = index
                          ? item.courses[index - 1].lessons.length
                          : 0;

                        const percent =
                          data.lessons.length > 0
                            ? Math.round(
                                (totalConfirm / data.lessons.length) * 100
                              )
                            : 0;
                        return (
                          <div
                            className="course"
                            style={{
                              opacity:
                                index == 0 ||
                                (totalBack && totalConfirmBack == totalBack)
                                  ? 1
                                  : 0.5,
                            }}
                          >
                            <p>{data.name}</p>
                            <img src={data.photo_url} />
                            <div className="infos">
                              <span>
                                {totalConfirm} de {data.lessons.length} aulas
                                confirmadas
                              </span>
                              <Progress
                                percent={percent}
                                status={percent == 100 ? "success" : "active"}
                                trailColor="#fff"
                              />
                              <Button
                                disabled={
                                  (index != 0 &&
                                    totalBack &&
                                    totalConfirmBack != totalBack) ||
                                  (index != 0 && !totalBack)
                                }
                                type="primary"
                                onClick={() => {
                                  if (
                                    user.course_restricted &&
                                    !item.restricted
                                  ) {
                                    toast.warn(
                                      "Curso restrito para franqueados"
                                    );
                                  } else {
                                    if (
                                      (index != 0 &&
                                        totalBack &&
                                        totalConfirmBack != totalBack) ||
                                      (index != 0 && !totalBack)
                                    ) {
                                      toast.warn(
                                        "Conclua o curso anterior para avançar"
                                      );
                                    } else {
                                      navigate(`/course/${data.id}`);
                                    }
                                  }
                                }}
                              >
                                <MdBook size={14} />
                                Ver Aulas
                              </Button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </>
      )}
    </Container>
  );
}
